import { render, staticRenderFns } from "./CustomInputDisplay.vue?vue&type=template&id=07c1b474&scoped=true"
import script from "./CustomInputDisplay.vue?vue&type=script&lang=js"
export * from "./CustomInputDisplay.vue?vue&type=script&lang=js"
import style0 from "./CustomInputDisplay.vue?vue&type=style&index=0&id=07c1b474&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c1b474",
  null
  
)

export default component.exports